export const environment = {
  production: true,
  urlDeployment: 'localhost',
  sentryDsn: 'https://2089a9b8fd6023317054f95020534763@o780420.ingest.sentry.io/4506237783834624',
  sentryEnv: 'PROD',
  appVersionUrlProduction: 'https://app.evidentist.cz/version.json',
  appVersionUrlStage: 'https://app.evidentist.cz.tomatomstage.cz/version.json',
}
